import { ProductHatProps } from '@wix/package-picker-components';
import { useTranslation } from 'react-i18next';
import { RootStore } from '../../../../../../providers';

export const useHatProperties = ({
  isCurrentPlan,
  isOnSale,
  isRecommended,
  text,
  salePercentages,
  isAllProductsOnSale,
  rootStore,
}: {
  isCurrentPlan?: boolean;
  isOnSale?: boolean;
  isRecommended?: boolean;
  text?: string;
  salePercentages?: number;
  isAllProductsOnSale?: boolean;
  rootStore: RootStore;
}): ProductHatProps | undefined => {
  const { t } = useTranslation();
  const { isInPermanentSale } = rootStore.appStore;

  let hatProperties;
  if (isRecommended) {
    hatProperties = {
      hatText: t(text || 'premium-purchase-plan.cards.hat.recommended'),
    };
  }

  if (isOnSale) {
    hatProperties = {
      hatText: t('premium-purchase-plan.cards.hat_sale', '50% OFF'),
      background: '#FF784B',
    };
  }

  if (salePercentages && !isAllProductsOnSale) {
    const hatKey = isInPermanentSale
      ? 'premium-purchase-plan.cards.permanent-sale.hat'
      : 'sale.product.x_off';
    hatProperties = {
      hatText: t(hatKey, { percent: salePercentages }),
      background: '#FF784B',
    };
  }

  if (isRecommended && isAllProductsOnSale) {
    hatProperties = {
      hatText: t(text || 'premium-purchase-plan.cards.hat.recommended'),
      background: 'linear-gradient(90deg, #FFB79E 0.01%, #FF6D3C 100%)',
    };
  }

  if (isCurrentPlan) {
    hatProperties = {
      hatText: t('premium-purchase-plan.cards.hat.current_plan'),
      background: '#EBEBEB',
      textWhite: false,
    };
  }

  return hatProperties;
};
